import React from "react";
import { elementType, oneOf, string } from "prop-types";
import { classes } from "../utils/classes";
import { fontSizePropTypes } from "../props/sx";

const Loader = ({ Tag = "div", color = "black", size = "m", className = "" }) => {
	return (
		<Tag
			className={classes(
				"loader",
				`loader-${size}`,
				`loader-color-${color}`,
				"loader--overlay",
				className,
			)}
		>
			<Tag className="loader__part" />
			<Tag className="loader__part" />
			<Tag className="loader__part" />
			<Tag className="loader__part" />
		</Tag>
	);
};

Loader.propTypes = {
	Tag: elementType,
	color: oneOf(["black", "white", "gray", "red", "green", "1", "2", "3", "4", "5"]),
	size: fontSizePropTypes,
	className: string,
};

export default Loader;
